/* tslint:disable */
/* eslint-disable */
/**
 * Assisted Webservices
 * Enables agents to provide real-time support to customers. For example, agents are able to find a customer account or cart, bind anonymous carts to customer accounts, and provide different customer lists relative to different business applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of an organizational approval process
 * @export
 * @interface B2BApprovalProcess
 */
export interface B2BApprovalProcess {
    /**
     * Code of the Organizational Approval Process
     * @type {string}
     * @memberof B2BApprovalProcess
     */
    code: string;
    /**
     * Name of the Organizational Approval Process
     * @type {string}
     * @memberof B2BApprovalProcess
     */
    name?: string;
}

/**
 * Check if a given object implements the B2BApprovalProcess interface.
 */
export function instanceOfB2BApprovalProcess(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function B2BApprovalProcessFromJSON(json: any): B2BApprovalProcess {
    return B2BApprovalProcessFromJSONTyped(json, false);
}

export function B2BApprovalProcessFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BApprovalProcess {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function B2BApprovalProcessToJSON(value?: B2BApprovalProcess | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

